export const DOC_LIST_FILTER_SET = 'DOC_LIST_FILTER_SET';
export const CHECK_LIST_FILTER_SET = 'CHECK_LIST_FILTER_SET';
export const USER_LIST_FILTER_SET = 'USER_LIST_FILTER_SET';
export const ORDER_LIST_FILTER_SET = 'ORDER_LIST_FILTER_SET';
export const EPSI_ORDER_LIST_FILTER_SET = 'EPSI_ORDER_LIST_FILTER_SET';
export const PUBLISHSET_LIST_FILTER_SET = 'PUBLISHSET_LIST_FILTER_SET';
export const SUBJECT_LIST_FILTER_SET = 'SUBJECT_LIST_FILTER_SET';
export const GEODESISTS_LIST_FILTER_SET = 'GEODESISTS_LIST_FILTER_SET';
export const ORGANIZATION_LIST_FILTER_SET = 'ORGANIZATION_LIST_FILTER_SET';
export const SVU_LIST_FILTER_SET = 'SVU_LIST_FILTER_SET';
export const PRICE_LIST_ITEM_LIST_FILTER_SET = 'PRICE_LIST_ITEM_LIST_FILTER_SET';
export const SERVICE_ORDER_LIST_FILTER_SET = 'SERVICE_ORDER_LIST_FILTER_SET';
